<template>
  <div class="column is-10">
    <div class="box">
      <div class="field">
        <label class="label">Select timezone</label>
        <div class="control">
          <div class="select">
            <select v-model="user.timezone">
              <option value="">Select Timezone</option>
              <option
                v-for="(timezone, index) in timezones"
                v-bind:key="index"
                :value="timezone.name"
              >
                {{ timezone.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="field">
        <div class="control">
          <button
            class="button is-primary"
            @click="saveTimezone"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TIMEZONES from '@/graphql/timezones/timezones.gql';
import USER from '@/graphql/user/user.gql';
import UPDATE_USER from '@/graphql/user/updateUser.gql';

export default {
  name: 'Timezone',
  data() {
    return {
      timezones: null,
      user: {
        timezone: null,
      },
    };
  },
  apollo: {
    timezones: TIMEZONES,
    user: USER,
  },
  methods: {
    saveTimezone() {
      this.$apollo.mutate({
        mutation: UPDATE_USER,
        variables: {
          id: this.user.id,
          timezone: this.user.timezone,
        },
      })
        .then((res) => {
          this.user = res.data.updateUser;
          this.$toasted.success('Timezone updated!');
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
    },
  },
};
</script>

<style scoped>

</style>
